import {CurrentPageStore} from '@/store/content-optimizer/currentPage';
import {useStore} from '@/store/root-store';
import {observer} from 'mobx-react';
import {useEffect, useRef} from 'react';
import {getLocalesByKey as t} from '@/utils/translation';
import {isScaPublicPage} from '../../../EditorSection/content-editor/utils';
import styles from '../style.module.scss';
import {SuggestedKeywordCard} from './SuggestedKeywordCard';


interface Props {
  store: CurrentPageStore;
  getCustomerQuota?: () => {};
  showSidebarPaymentDrawer?: any;
  quotaUtilization?: any;
}

export const KeywordSuggestions = observer(({store, getCustomerQuota, showSidebarPaymentDrawer, quotaUtilization}: Props) => {
  const {keywordResearcherV2: {postNewKeywords, keywordDetails: {loadKeywordDetailList, loadKeywordDetails, setDetailsRepolling}}} = useStore('');


  const keywordSuggestionsContainer = useRef(null);

  useEffect(() => {
    const addHorizontalScroll = e => {
      // If we are scrolling inside suggestions container
      if (keywordSuggestionsContainer.current && keywordSuggestionsContainer.current.contains(e.target)) {
        // Disable vertical scroll for main container
        const topScroll = window.scrollY;
        const leftScroll = window.scrollX;
        window.onscroll = e => {
          e.preventDefault();
          window.scrollTo(leftScroll, topScroll);
        };
        // Scroll suggestions container
        if (e.deltaY > 0) {
          if (e.deltaY > 50) {
            keywordSuggestionsContainer.current.scrollLeft += 30;
          } else {
            keywordSuggestionsContainer.current.scrollLeft += e.deltaY;
          }
        } else {
          if ((e.deltaY * -1) > 50) {
            keywordSuggestionsContainer.current.scrollLeft -= 30;
          } else {
            keywordSuggestionsContainer.current.scrollLeft -= (e.deltaY * -1);
          }
        }
      } else if (keywordSuggestionsContainer.current && !keywordSuggestionsContainer.current.contains(e.target)) {
        // Enable vertical scroll for main container
        window.onscroll = () => {};
      }
    };

    document.addEventListener('wheel', addHorizontalScroll);

    return () => {
      document.removeEventListener('wheel', addHorizontalScroll);
    };
  }, [keywordSuggestionsContainer]);


  const getKwSuggestionsMessage = () => {
    if (store.isFetchingSuggestedKw) {
      return t('loading-kw-suggestions');
    }

    if (!store.content?.editorText?.length && !store?.feTargetKeywords?.length) {
      return t('start-writing-or-add-target-kw');
    }

    if (store.content?.editorText?.length && !store?.feTargetKeywords?.length) {
      return t('add-one-target-keyword');
    }

    if (!store.content?.editorText?.length && store?.feTargetKeywords?.length) {
      return t('start-writing-content-to-see-kw-suggestions');
    }
    return t('edit-content-or-add-new-target-kw');
    // return t('could-not-load-target-keywords');
  };

  const postAndGetData = async (keyword, countryCode, locationId) => {
    const data = {'name': keyword, 'keywords': [`${keyword}`], 'is_recent_search': true};
    if (locationId) {
      data['location_id'] = locationId;
    } else {
      data['country_code'] = countryCode ? countryCode : '';
    }
    const response = await postNewKeywords(data);
    setDetailsRepolling(true);
    if (response?.id && response?.keywords?.length) {
      loadKeywordDetailList(response.id);
      loadKeywordDetails(response?.id, response?.keywords[0], response?.locationId, response?.countryCode);
    }
  };

  const showAllSuggestionsHandler = () => {
    if (isScaPublicPage()) return;
    if (store?.content?.targetKeywords?.length) {
      const keyword = [...store.content.targetKeywords][0]?.keyword;

      const countryCode = keyword?.countryCode || '';
      const location = keyword?.locationId || null;
      store.setIsDrawerFromCa(true);
      store.setActiveTargetKw(keyword);
      store.setIsOpenKeywordDrawer(true);
      postAndGetData(keyword, countryCode, location);
    }
  };


  return <div style={{display: 'flex'}}>
    {store.content.kwSuggestions.length ? <div style={{color: '#2D6CCA', fontSize: 12, marginRight: 6, width: 195, height: 20, marginTop: 4, cursor: 'pointer'}} onClick={() => showAllSuggestionsHandler()}>
      {`All Suggested Keywords (${store.content.kwSuggestions.length}):`}
    </div> : null}
    <div className={styles.keywordSuggestionsContainer} ref={keywordSuggestionsContainer}>
      {store.content.kwSuggestions.length ? store.content.kwSuggestions.map((kw, index) => {
        if (kw.keyword && index < 6) {
          return <SuggestedKeywordCard
            key={kw.keyword}
            store={store}
            kw={kw}
            getCustomerQuota={getCustomerQuota}
            showSidebarPaymentDrawer={showSidebarPaymentDrawer}
            quotaUtilization={quotaUtilization}
          />;
        }
      }) : <p style={{color: '#A3A4A4', marginTop: 0, fontSize: 12}}>{getKwSuggestionsMessage()}</p>}
    </div>
  </div>;
});
